/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ElectroSelectWithOther from 'forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';
import Form from 'forms/_.extend';

import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class DisableAccountForm extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const currentAccountDetails: Object = this.props.currentAccountDetails;
    const form: Form = this.props.form;

    const accountDetails: Array<*> = [
      [t('general:trading_account'), currentAccountDetails.name],
      [t('general:trading_accounts.labels.number'), currentAccountDetails.account_no],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:trading_accounts.labels.details')}
          >
            <ActionDrawerTable data={accountDetails} />
          </ActionDrawerBlock>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:trading_accounts.reasons.why_disable')}
          >
            <ElectroSelectWithOther
              field={form.$('disableAccountForm.reason')}
              otherHeading={`${t('general:reasons.provide_reason')} *`}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.disable_account')} />
      </React.Fragment>
    );
  }
}
